/* Timbrica — /meteor-showers (next shower, peak countdown, radiant + moon).
 *
 * 100% offline: a hand-kept table of the major annual showers (IMO/AMS) plus
 * in-browser astronomy (SunCalc-style) to work out, for your location: when the
 * radiant is up, when the sky is dark, and how much the Moon will wash meteors
 * out — then a peak countdown and a procedural shooting-star sky. No API.
 */
(function () {
  'use strict';
  var C = window.METEOR_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  // Таблица потоков переехала в config/meteor-showers.php: оттуда её берут
  // ОБА потребителя — этот движок и серверная справочная таблица на странице.
  // Порядок полей прежний: [pkMonth, pkDay, raDeg, decDeg, zhr, velocity,
  // activeFrom, activeTo]; блейд отдаёт её позиционно, чтобы математика ниже
  // осталась нетронутой.
  var SHOWERS = C.showers || [];

  // ── astronomy (SunCalc-style, BSD-2) ───────────────────────────────────────
  var PI = Math.PI, rad = PI / 180, dayMs = 864e5, J2000 = 2451545;
  function toDays(d) { return d.valueOf() / dayMs - 0.5 + 2440588 - J2000; }
  function ra(l, b) { var e = rad * 23.4397; return Math.atan2(Math.sin(l) * Math.cos(e) - Math.tan(b) * Math.sin(e), Math.cos(l)); }
  function dec(l, b) { var e = rad * 23.4397; return Math.asin(Math.sin(b) * Math.cos(e) + Math.cos(b) * Math.sin(e) * Math.sin(l)); }
  function sidereal(d, lw) { return rad * (280.16 + 360.9856235 * d) - lw; }
  function alt(H, phi, dc) { return Math.asin(Math.sin(phi) * Math.sin(dc) + Math.cos(phi) * Math.cos(dc) * Math.cos(H)); }
  function azi(H, phi, dc) { return Math.atan2(Math.sin(H), Math.cos(H) * Math.sin(phi) - Math.tan(dc) * Math.cos(phi)); }
  function sma(d) { return rad * (357.5291 + 0.98560028 * d); }
  function ecl(M) { return M + rad * (1.9148 * Math.sin(M) + 0.02 * Math.sin(2 * M) + 0.0003 * Math.sin(3 * M)) + rad * 102.9372 + PI; }
  function sunDec(date) { var d = toDays(date), L = ecl(sma(d)); return { dec: dec(L, 0), ra: ra(L, 0) }; }
  function sunAltDeg(date, lat, lng) { var lw = rad * -lng, phi = rad * lat, d = toDays(date), s = sunDec(date), H = sidereal(d, lw) - s.ra; return alt(H, phi, s.dec) / rad; }
  function moonCoords(d) { var L = rad * (218.316 + 13.176396 * d), M = rad * (134.963 + 13.064993 * d), F = rad * (93.272 + 13.229350 * d), l = L + rad * 6.289 * Math.sin(M), b = rad * 5.128 * Math.sin(F); return { ra: ra(l, b), dec: dec(l, b), L: L, M: M }; }
  function moonAltDeg(date, lat, lng) { var lw = rad * -lng, phi = rad * lat, d = toDays(date), c = moonCoords(d), H = sidereal(d, lw) - c.ra; return alt(H, phi, c.dec) / rad; }
  function moonIllum(date) { var d = toDays(date), s = sunDec(date), m = moonCoords(d), sd = 149598000, mdist = 385001 - 20905 * Math.cos(m.M), phi = Math.acos(Math.sin(s.dec) * Math.sin(m.dec) + Math.cos(s.dec) * Math.cos(m.dec) * Math.cos(s.ra - m.ra)), inc = Math.atan2(sd * Math.sin(phi), mdist - sd * Math.cos(phi)); return (1 + Math.cos(inc)) / 2; }
  // radiant altitude from RA/Dec (deg) at a place & time
  function radiantAltAz(date, lat, lng, raDeg, decDeg) { var lw = rad * -lng, phi = rad * lat, d = toDays(date), H = sidereal(d, lw) - raDeg * rad, dc = decDeg * rad; return { alt: alt(H, phi, dc) / rad, az: (azi(H, phi, dc) / rad + 180 + 360) % 360 }; }
  function compass(az) { var c = tr('compass').split(','); return c[Math.round(az / 45) % 8]; }

  // ── shower scheduling ──────────────────────────────────────────────────────
  function peakDate(sh, year) { return new Date(Date.UTC(year, sh[0] - 1, sh[1], 22, 0, 0)); }
  function nextPeak(sh) { var now = new Date(), y = now.getUTCFullYear(), p = peakDate(sh, y); if (p.valueOf() < now.valueOf() - 2 * dayMs) p = peakDate(sh, y + 1); return p; }

  // night analysis for a shower at a location (steps through the coming ~14h)
  function analyse(sh, lat, lon) {
    var now = Date.now(), best = -90, bestT = null, darkFrom = null, darkTo = null, moonUpIll = 0, good = false;
    for (var t = now; t < now + 14 * 3600e3; t += 20 * 60e3) {
      var d = new Date(t), sa = sunAltDeg(d, lat, lon), rAlt = radiantAltAz(d, lat, lon, sh[2], sh[3]).alt;
      var dark = sa < -12;
      if (dark) { if (darkFrom == null) darkFrom = t; darkTo = t; if (rAlt > 10) { good = true; if (rAlt > best) { best = rAlt; bestT = t; } var ma = moonAltDeg(d, lat, lon); if (ma > 0) moonUpIll = Math.max(moonUpIll, moonIllum(d) * Math.min(1, (ma / 30))); } }
    }
    return { maxAlt: best, bestT: bestT, darkFrom: darkFrom, darkTo: darkTo, moonUpIll: moonUpIll, good: good, polar: darkFrom == null };
  }
  function moonVerdict(ill) { return ill > 0.55 ? 'moon_strong' : ill > 0.25 ? 'moon_some' : 'moon_none'; }

  var loc = null, fromGeo = false;
  function locOffsetMin() { return fromGeo ? -new Date().getTimezoneOffset() : (loc ? Math.round(loc[1] / 15) * 60 : 0); }
  function hhmm(ms) { if (ms == null) return '—'; var d = new Date(ms + locOffsetMin() * 60000); try { return d.toLocaleTimeString(C.locale, { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); } catch (x) { return d.toISOString().slice(11, 16); } }
  function countdown(ms) { var s = Math.max(0, (ms - Date.now()) / 1000), dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60); if (dd > 0) return dd + tr('d_short') + ' ' + hh + tr('h_short'); if (hh > 0) return hh + tr('h_short') + ' ' + mm + tr('m_short'); return mm + tr('m_short'); }

  function names() { return tr('showers').split('|'); }

  function render() {
    if (!loc) return;
    var nm = names();
    var list = SHOWERS.map(function (sh, i) { return { i: i, sh: sh, peak: nextPeak(sh).valueOf() }; }).sort(function (a, b) { return a.peak - b.peak; });
    var next = list[0], sh = next.sh, a = analyse(sh, loc[0], loc[1]);

    // hero
    $('mtName').textContent = nm[next.i];
    $('mtCountdown').textContent = countdown(next.peak);
    $('mtPeakDate').textContent = tr('peak') + ': ' + new Date(next.peak + locOffsetMin() * 60000).toLocaleDateString(C.locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    $('mtZhr').textContent = sh[4] + ' ' + tr('per_hour');
    $('mtVel').textContent = sh[5] + ' ' + tr('kms');
    var rad1 = a.maxAlt > 10 ? (a.maxAlt > 50 ? tr('radiant_high') : tr('radiant_ok')) + ' (' + Math.round(a.maxAlt) + '°)' : tr('radiant_low');
    $('mtRadiant').textContent = a.polar ? tr('too_bright') : rad1;
    $('mtBest').textContent = a.polar ? tr('too_bright') : (a.good ? (tr('best_after') + ' ' + hhmm(a.darkFrom)) : tr('not_tonight'));
    var mv = moonVerdict(a.moonUpIll);
    $('mtMoon').textContent = tr(mv) + ' (' + Math.round(moonIllum(new Date()) * 100) + '%)';
    $('mtMoon').className = 'mt-moon ' + (mv === 'moon_strong' ? 'bad' : mv === 'moon_none' ? 'good' : '');

    // upcoming list (next 5)
    var ul = $('mtList'); ul.innerHTML = '';
    list.slice(0, 6).forEach(function (it) {
      var li = document.createElement('div'); li.className = 'mt-row';
      li.innerHTML = '<span class="mt-row-n">' + nm[it.i] + '</span><span class="mt-row-d">' + new Date(it.peak + locOffsetMin() * 60000).toLocaleDateString(C.locale, { day: 'numeric', month: 'short', timeZone: 'UTC' }) + '</span><span class="mt-row-z">' + it.sh[4] + '/' + tr('h_short') + '</span>';
      ul.appendChild(li);
    });
  }

  function locate() {
    // A bare `return` here was a literally silent dead click: the button
    // did nothing and said nothing. __geo.notify explains why and reports it.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    var b = $('mtLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) { loc = [pos.coords.latitude, pos.coords.longitude]; fromGeo = true; render(); ae('feature_use', { slug: 'meteor-showers', feature: 'locate' }); if (b) b.disabled = false; },
      function (err) { if (b) b.disabled = false; if (window.__geo) __geo.notify(err); }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  // ── procedural shooting-star sky (ambiance) ────────────────────────────────
  function sky() {
    var cv = $('mtSky'); if (!cv) return; var ctx = cv.getContext('2d'), stars = [], shots = [], W, H, dpr = window.devicePixelRatio || 1;
    function resize() { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); stars = []; for (var i = 0; i < Math.round(W * H / 6000); i++) stars.push([Math.random() * W, Math.random() * H, Math.random() * 1.4 + 0.2, Math.random()]); }
    resize(); window.addEventListener('resize', resize);
    var last = 0, acc = 0;
    function frame(ts) {
      var dt = last ? ts - last : 16; last = ts; acc += dt;
      ctx.fillStyle = '#070b16'; ctx.fillRect(0, 0, W, H);
      for (var i = 0; i < stars.length; i++) { var s = stars[i]; s[3] += dt * 0.001; var tw = 0.5 + 0.5 * Math.sin(s[3]); ctx.globalAlpha = 0.25 + tw * 0.55; ctx.fillStyle = '#cfe0ff'; ctx.fillRect(s[0], s[1], s[2], s[2]); }
      ctx.globalAlpha = 1;
      if (acc > 700 && Math.random() < 0.5) { acc = 0; var x = Math.random() * W * 0.8 + W * 0.1, y = Math.random() * H * 0.4; shots.push({ x: x, y: y, vx: -2 - Math.random() * 2, vy: 1.6 + Math.random(), life: 0 }); }
      for (var j = shots.length - 1; j >= 0; j--) { var p = shots[j]; p.life += dt; p.x += p.vx * dt * 0.06; p.y += p.vy * dt * 0.06; var a = Math.max(0, 1 - p.life / 1100); ctx.strokeStyle = 'rgba(255,245,210,' + a + ')'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x - p.vx * 9, p.y - p.vy * 9); ctx.stroke(); if (p.life > 1100) shots.splice(j, 1); }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    try { window.Timbrica3D && window.Timbrica3D.init && window.Timbrica3D.init('meteor-showers'); } catch (e) {}
    loc = [C.home.lat, C.home.lon]; fromGeo = false;
    sky(); render();
    var lb = $('mtLocate'); if (lb) lb.addEventListener('click', locate);
    setInterval(render, 60000);
    ae('tool_complete', { slug: 'meteor-showers' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
